import { createSlice } from "@reduxjs/toolkit";

const defaultPagination = {
  page: 0,
  pageSize: 50,
};

const baseFilterState = {
  pagination: { ...defaultPagination },
  search: "",
  startDate: "",
  endDate: "",
  createStartDate: "",
  createEndDate: "",
  clientId: "",
  projectId: "",
  clientIds: [],
  teamIds: [],
  teamId: "",
  provider: { value: "", label: "" },
  country: { value: "", label: "" },
  city: { value: "", label: "" },
  createdById: "",
  id: "",
  minRate: "",
  maxRate: "",
  minRequests: "",
  maxRequests: "",
  categoryId: "",
  vendorId: "",
  subCategoryIds: [],
  paymentType: "",
  status: [],
  currency: "",
  engineerCurrency: "",
  canceledBy: "",
  cancellationReason: "",
  appliedFromDrawer: false,
};

const initialState = {
  workOrders: { ...baseFilterState },
  customerWorkOrders: { ...baseFilterState },
};

const clientFiltersSlice = createSlice({
  name: "clientFilters",
  initialState,
  reducers: {
    setClientFilters: (state, action) => {
      const { module, filterName, data } = action.payload;

      if (!state[module]) return; // guard against invalid module

      if (filterName === "pagination") {
        state[module].pagination = {
          ...state[module].pagination,
          ...data,
        };
      } else if (filterName.includes(".")) {
        const [parent, child] = filterName.split(".");
        if (state[module][parent]) {
          state[module][parent][child] = data;
        }
      } else {
        state[module][filterName] = data;
      }
    },

    resetClientFilters: (state, action) => {
      const { module } = action.payload;
      if (initialState[module]) {
        state[module] = { ...initialState[module] };
      }
    },

    resetClientPagination: (state, action) => {
      const { module } = action.payload;
      if (state[module]) {
        state[module].pagination = { ...defaultPagination };
      }
    },
  },
});

export const { setClientFilters, resetClientFilters, resetClientPagination } =
  clientFiltersSlice.actions;

export default clientFiltersSlice.reducer;
